const translations = {
    en: {
        restaurants: {
            header: "BREAKFAST & RESTAURANTS",
            title: "<strong>Hungry?</strong><br/><strong>No Problem.</strong>",
            text: "Here you will find all that you need in order to make your stay as pleasant as possible at "
        }
    },
    de: {
        restaurants: {
            header: "FRÜHSTÜCK & RESTAURANTS",
            title: "<strong>Hunger?</strong><br/><strong>Kein Problem.</strong>",
            text: "Hier finden Sie alles, was Sie brauchen, um Ihren Aufenthalt so angenehm wie möglich zu gestalten "
        }
    },
    es: {
        restaurants: {
            header: "DESAYUNO Y RESTAURANTES",
            title: "<strong>Tiene Hambre?</strong><br/><strong>Ningun problema.</strong>",
            text: "Aqui podrà encontrar todo lo que haga falta para que su estancia sea lo más agradable posible "
        }
    },
    fr: {
        restaurants: {
            header: "PETIT DÉJEUNER & RESTAURANTS",
            title: "<strong>Avez-vous faim?</strong><br/><strong>Pas de problème.</strong>",
            text: "Ici vous trouverez tout ce dont vous avez besoin pour rendre votre séjour le plus agréable possible au "
        }
    },
    it: {
        restaurants: {
            header: "COLAZIONE & RISTORANTI",
            title: "<strong>Affamato?</strong><br/><strong>Nessun problema.</strong>",
            text: "Qui troverai tutto ciò di cui hai bisogno per rendere il tuo soggiorno il più piacevole possibile al "
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/restaurants/Restaurants.js